import { WorkingHoursErrors } from './types'

export const checkWorkingHourErrorsExist = (
  workingHourErrors: WorkingHoursErrors
) =>
  Object.values(workingHourErrors).some((workingHour) =>
    Object.values(workingHour).some((el) => el)
  )
